// @avantia common-code
import { intervalToMs, isTrue, toEnumFlags } from '@avantia/client-and-server-utilities';
import { lodash } from '@avantia/lodash';
import { HpEnvironmentTypes } from '@avantia/server-base';
import { HpClaimsDebugFlags } from '../clientLogging';
import { HpClientDebugFlags } from '../engineClient/clientDebugFlags';
import { HpClaimsClientConfiguration } from './configurationTypes';

export function getConfig(): HpClaimsClientConfiguration {
  const virtualPath = lodash.trimEnd('/', '/');
  const config: HpClaimsClientConfiguration = {
    allowSiteViewErrorSimulation: isTrue('false'),
    answersKey: 'hpAnswersId',
    artemisPasWeb: 'https://portal.homeprotect.co.uk/ArtemisPasWeb/',
    azureAdClientId: '178eaa07-7527-4fc6-8516-5ca94f46c43a',
    azureAdTenantId: 'fac35918-f111-49f4-889d-e209be7ea18d',
    clientDebugFlags: toEnumFlags('Configuration', HpClientDebugFlags as any),
    cookieScope: 'per-tab' as any,
    ddApplicationId: '534bbeae-0431-4809-b151-2c8d80e72099',
    ddClientToken: 'pub35f3008d3c898bcb17b217ef8881693b',
    ddCompressInTakeRequests: isTrue(''),
    ddRumEnabled: isTrue('true'),
    ddRumSessionRecordingEnabled: isTrue('true'),
    ddSessionReplaySampleRate: 0,
    ddUsePartitionedCrossSiteSessionCookie: isTrue(''),
    ddSampleRate: parseInt('100', 10),
    ddServiceName: 'claimsenquiryportal',
    ddTrackInteractions: isTrue('true'),
    ddTrackResources: isTrue('true'),
    dependentActionTimeoutMs: intervalToMs('60s'),
    developerModeEnabled: isTrue('false'),
    environment: 'liv' as HpEnvironmentTypes,
    environmentLevelName: 'Live',
    evanMinVersion: '1.1.0.0',
    experimentsKey: 'hpExperiments',
    florenceMinVersion: '1.2.0.0',
    gaTrackingId: 'AW-1066593055',
    googleAnalyticsEnabled: isTrue('true'),
    gtmEnabled: isTrue('true'),
    gtmId: 'GTM-MRGVM6',
    homeProtectUrl: 'https://homeprotect.co.uk',
    hotjarEnabled: isTrue('true'),
    isClaimsRoutingEnabled: isTrue('false'),
    hotjarId: parseFloat('185815'),
    hotjarTrackingCode: parseFloat('6'),
    hpPhoneNumber: '0330 660 0660',
    isAuthenticationEnabled: false,
    optimisationEnabled: isTrue('false'),
    productIdDefault: '35d65b5d-e0ac-4f68-8251-10d77658e397',
    productKey: 'hpProductId',
    claimsDebugFlags: toEnumFlags('Configuration', HpClaimsDebugFlags as any),
    releaseVersion: '1.0.2555.260352',
    showErrorPageAfterConsecutiveErrorCount: parseFloat('3'),
    siteViewRedirectUrl: 'https://homeprotect.360sv.com/#/meeting/',
    virtualPath,
    websiteEndpoint: virtualPath,
    assetsUrl: 'https://assets.homeprotect.co.uk/',
    logoPath: 'website/homeprotect_final_logo.svg',
    customerPortalPassbackUrl: 'https://customers.homeprotect.co.uk/',
    websiteBaseUrl: 'https://claim.homeprotect.co.uk',
    websiteExternalUrl: 'https://claim.homeprotect.co.uk',
    whenToEvaluatePrerequisites: 'both',
    validateOnBackNavigation: false
  };

  return config;
}
